import { render, staticRenderFns } from "./ErrorDashboard.vue?vue&type=template&id=28ff6b88"
import script from "./ErrorDashboard.vue?vue&type=script&lang=js"
export * from "./ErrorDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports